export default __webpack_public_path__ + "static/media/education.2df6bb07.webp";